import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Form from "../components/Form"

const IndexPage = () => {
  return (
    <Layout>
      <Seo title="Bezmailovka" />
      <Form/>
    </Layout>
  )
}

export default IndexPage